"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DDEmailApi = exports.DDCampaignApi = exports.DDSmsApi = exports.DDCpaasApi = exports.DDDataFieldsApi = exports.DDEnrolmentApi = exports.DDListsApi = exports.DDContactApi = void 0;
__exportStar(require("./friendbuy/commonFields"), exports);
__exportStar(require("./friendbuy/contextFields"), exports);
__exportStar(require("./friendbuy/mapEvent"), exports);
__exportStar(require("./friendbuy/sharedCustomer"), exports);
__exportStar(require("./friendbuy/sharedCustomEvent"), exports);
__exportStar(require("./friendbuy/sharedPurchase"), exports);
__exportStar(require("./friendbuy/sharedSignUp"), exports);
__exportStar(require("./friendbuy/util"), exports);
__exportStar(require("./engage/utils"), exports);
__exportStar(require("./dotdigital/api/types"), exports);
__exportStar(require("./dotdigital/helpers/functions"), exports);
var api_1 = require("./dotdigital/api");
Object.defineProperty(exports, "DDContactApi", { enumerable: true, get: function () { return api_1.DDContactApi; } });
Object.defineProperty(exports, "DDListsApi", { enumerable: true, get: function () { return api_1.DDListsApi; } });
Object.defineProperty(exports, "DDEnrolmentApi", { enumerable: true, get: function () { return api_1.DDEnrolmentApi; } });
Object.defineProperty(exports, "DDDataFieldsApi", { enumerable: true, get: function () { return api_1.DDDataFieldsApi; } });
Object.defineProperty(exports, "DDCpaasApi", { enumerable: true, get: function () { return api_1.DDCpaasApi; } });
Object.defineProperty(exports, "DDSmsApi", { enumerable: true, get: function () { return api_1.DDSmsApi; } });
Object.defineProperty(exports, "DDCampaignApi", { enumerable: true, get: function () { return api_1.DDCampaignApi; } });
Object.defineProperty(exports, "DDEmailApi", { enumerable: true, get: function () { return api_1.DDEmailApi; } });
//# sourceMappingURL=index.js.map